import React, { useCallback, useEffect } from "react";
import {
	Alert,
	Box,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	Radio,
	RadioGroup,
	Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import style from "./Form.module.css";
import Block from "../../../../common/components/customizable-form/block/Block";
import styles from "../../../../common/components/customizable-form/block/Block.module.css";
import { CustomDialog, CustomTextField } from "../../../../common/components";
import { setUpdateLicenceManagement } from "../../../../common/slice";
import { checkEmail } from "../../../../common/utils";
import { translate } from "../../../../common/providers";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";
import PaginationBlock from "./PaginationBlock";

export default function FormAddProfile() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const listAllCompanies = useSelector(({ context }) => context.licenceManagement?.listAllCompanies);
	const dispatch = useDispatch();
	const [valueProfile, setValueProfile] = React.useState("");
	const [valueCertificate, setValueCertificate] = React.useState("0");
	const [valueEngagementTracking, setValueEngagementTracking] = React.useState("0");
	const [selectTerritories, setSelectedTerritories] = React.useState([]);
	const [optionsProfiles, setOptionsProfiles] = React.useState([]);
	const [openModalFilter, setOpenModalFilter] = React.useState(false);
	const [error, setError] = React.useState(false);
	const { call: getProfile } = useApi(LicenceManagementService.getProfile);
	const { call: getAllListBU } = useApi(LicenceManagementService.getAllListBU);

	const onGlobalUpdateTerritories = ({ valueUuid, value, checked }) => {
		if (checked) {
			setSelectedTerritories([...selectTerritories, { valueUuid, value }]);
		} else {
			const oldValue = selectTerritories;
			const exit = oldValue?.filter((item) => item.value === value);

			if (exit.length > 0) {
				const newValue = oldValue?.filter((item) => item.value !== value);
				setSelectedTerritories(newValue);
			}
		}
	};
	useEffect(() => {
		getProfile()
			.then((data) => {
				setOptionsProfiles(data);
			})
			.catch(console.error);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		getAllListBU(licenceManagementStore?.listAllCompanies?.params)
			.then((data) => {
				const items = data.contents?.map((item) => ({ name: item.companyName, uuid: item.id }));
				const newData = { ...licenceManagementStore?.listAllCompanies, ...data, items };

				dispatch(
					setUpdateLicenceManagement({
						listAllCompanies: newData,
					})
				);
			})
			.catch(console.error);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [licenceManagementStore?.listAllCompanies?.params]);

	const searchAllListCompanyByBuName = useCallback(
		(v) => {
			dispatch(
				setUpdateLicenceManagement({
					listAllCompanies: {
						...listAllCompanies,
						params: {
							...listAllCompanies?.params,
							payload: { ...listAllCompanies?.params?.payload, buName: v },
							page: 0,
							limit: listAllCompanies?.params?.limit || 75,
						},
					},
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[dispatch]
	);
	const handleUpdateLicenceManagement = (e) => {
		dispatch(
			setUpdateLicenceManagement({
				addUser: {
					...licenceManagementStore?.addUser,
					contracts: e.target.checked,
					bu: e.target.checked ? null : licenceManagementStore?.addUser?.bu,
				},
			})
		);
	};
	const ctaSelectAllBu = () => (
		<FormControlLabel
			control={
				<Checkbox
					checked={licenceManagementStore?.addUser?.contracts}
					onChange={handleUpdateLicenceManagement}
				/>
			}
			label={translate("common:licence-management.label.all-bu")}
		/>
	);
	const handleClose = () => {
		setSelectedTerritories(licenceManagementStore?.addUser?.bu || []);
		setOpenModalFilter(false);
	};

	return (
		<Grid container bgcolor="white" p={2}>
			<Grid item md={12} py={1}>
				<div className={styles.caption}>
					<span>{translate("common:register.first-name.label")}</span>
					<span>*</span>
				</div>
				<CustomTextField
					fullWidth
					required
					placeholder={translate("common:register.first-name.label")}
					size="small"
					value={licenceManagementStore?.addUser?.firstname}
					onChange={(e) =>
						dispatch(
							setUpdateLicenceManagement({
								addUser: { ...licenceManagementStore?.addUser, firstname: e.target.value },
							})
						)
					}
				/>
			</Grid>
			<Grid item md={12} py={1}>
				<div className={styles.caption}>
					<span>{translate("common:register.last-name.label")}</span>
					<span>*</span>
				</div>
				<CustomTextField
					fullWidth
					required
					placeholder={translate("common:register.last-name.label")}
					size="small"
					value={licenceManagementStore?.addUser?.lastname}
					onChange={(e) =>
						dispatch(
							setUpdateLicenceManagement({
								addUser: { ...licenceManagementStore?.addUser, lastname: e.target.value },
							})
						)
					}
				/>
			</Grid>
			<Grid item md={12} py={1}>
				<div className={styles.caption}>
					<span>{translate("common:register.email.label")}</span>
					<span>*</span>
				</div>
				<CustomTextField
					fullWidth
					required
					error={error}
					placeholder={translate("common:register.email.label")}
					size="small"
					type="email"
					value={licenceManagementStore?.addUser?.email}
					onChange={(e) => {
						if (checkEmail(e.target.value)) {
							setError(false);
						} else {
							setError(true);
						}
						dispatch(
							setUpdateLicenceManagement({
								addUser: { ...licenceManagementStore?.addUser, email: e.target.value },
							})
						);
					}}
				/>
			</Grid>
			<Grid item md={12} py={1}>
				<div className={styles.caption}>
					<span>{translate("common:licence-management.label.profile")}</span>
					<span>*</span>
				</div>
				<Autocomplete
					getOptionLabel={(option) => option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()}
					options={optionsProfiles}
					renderInput={(params) => (
						<CustomTextField
							{...params}
							placeholder={translate("common:licence-management.label.profile")}
							variant="outlined"
						/>
					)}
					size="small"
					sx={{ width: "100%", textTransform: "capitalize" }}
					value={valueProfile}
					onChange={(event, v) => {
						setValueProfile(v);
						dispatch(
							setUpdateLicenceManagement({
								addUser: { ...licenceManagementStore?.addUser, role: v },
							})
						);
					}}
				/>
			</Grid>
			<Grid item md={12} p={1}>
				<Box className={style.box}>
					<Grid container className={style.boxTitle} p={1}>
						<Typography variant="subtitle1">
							{translate("license-management.user-view.contrats")}
						</Typography>
					</Grid>
					<Grid container item bgcolor="white" md={12} p={2}>
						<Grid container py={1}>
							<Grid iem md={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={licenceManagementStore?.addUser?.contracts}
											onChange={handleUpdateLicenceManagement}
										/>
									}
									label={translate("common:licence-management.label.all-bu")}
								/>
							</Grid>

							{!licenceManagementStore?.addUser?.contracts && (
								<Grid container>
									<div className={styles.caption}>
										<span>{translate("common:licence-management.label.bu")}</span>
									</div>

									<Grid item md={12}>
										<CustomTextField
											fullWidth
											placeholder={translate("common:licence-management.label.bu")}
											size="small"
											value={selectTerritories?.map((v) => v.value).join(", ")}
											onClick={() => setOpenModalFilter(true)}
										/>
									</Grid>
								</Grid>
							)}

							<Grid container py={2}>
								<Grid item md={12}>
									<Typography fontWeight="bold" pb={1} variant="subtitle2">
										{translate("common:portfolio-tab-navigation.suiviengagements")}
									</Typography>
									<FormControl>
										<RadioGroup
											value={valueEngagementTracking}
											onChange={(e) => {
												setValueEngagementTracking(e.target.value);
												dispatch(
													setUpdateLicenceManagement({
														addUser: {
															...licenceManagementStore?.addUser,
															engagementTracking: e.target.value === "1",
														},
													})
												);
											}}
										>
											<FormControlLabel
												control={<Radio />}
												label={translate(
													"common:licence-management.label.active-access-commitment-tracking"
												)}
												value="1"
											/>
											<FormControlLabel
												control={<Radio />}
												label={translate(
													"common:licence-management.label.inactive-access-commitment-tracking"
												)}
												value="0"
											/>
										</RadioGroup>
									</FormControl>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</Grid>
			<Grid item md={12} p={1}>
				<Box className={style.box}>
					<Grid container className={style.boxTitle} p={1}>
						<Typography variant="subtitle1">
							{translate("license-management.user-view.certificats")}
						</Typography>
					</Grid>
					<Grid container bgcolor="white" p={2}>
						<FormControl>
							<RadioGroup
								value={valueCertificate}
								onChange={(e) => {
									setValueCertificate(e.target.value);
									dispatch(
										setUpdateLicenceManagement({
											addUser: {
												...licenceManagementStore?.addUser,
												certificates: e.target.value === "1",
											},
										})
									);
								}}
							>
								<FormControlLabel
									control={<Radio />}
									label={translate("common:licence-management.label.active-access-certificat")}
									value="1"
								/>
								<FormControlLabel
									control={<Radio />}
									label={translate("common:licence-management.label.inactive-access-certificat")}
									value="0"
								/>
							</RadioGroup>
						</FormControl>
					</Grid>
				</Box>
			</Grid>
			<CustomDialog
				displayCloseCross
				isForm
				open={openModalFilter}
				title={translate("common:licence-management.label.bu")}
				onClose={handleClose}
				onSubmit={() => {
					dispatch(
						setUpdateLicenceManagement({
							addUser: {
								...licenceManagementStore?.addUser,
								bu: selectTerritories,
							},
						})
					);
					setOpenModalFilter(false);
				}}
			>
				<Block
					hiddenLabel
					addActionFilter={ctaSelectAllBu()}
					block={{
						id: "",
						type: "CATEGORY",
						name: translate("common:licence-management.label.territories"),
						options: {
							isMandatory: false,
							items: licenceManagementStore?.listAllCompanies?.items,
							currentValue: selectTerritories,
						},
					}}
					deleteSelection={() => {
						setSelectedTerritories([]);
					}}
					editMode={false}
					pagination={licenceManagementStore.addUser.contracts ? null : <PaginationBlock />}
					showText={
						licenceManagementStore.addUser.contracts ? (
							<Alert>{translate("common:licence-management.label.selected-all-bu")}</Alert>
						) : null
					}
					onGlobalUpdate={onGlobalUpdateTerritories}
					onSearch={searchAllListCompanyByBuName}
				/>
			</CustomDialog>
		</Grid>
	);
}
